import React, { useState, useContext } from "react";
import { logIn, AuthContext } from "../services/firebase";
import { Button, InlineLoading } from "carbon-components-react";
import { FaceMask32, Login16 } from "@carbon/icons-react";
import { Redirect } from "react-router-dom";

function Login() {
  const [status, setStatus] = useState(null);
  if (status == null)
    return (
      <Button
        renderIcon={Login16}
        style={{ justifyContent: "center" }}
        onClick={() => {
          setStatus("active");
          logIn(setStatus);
        }}
      >
        Login
      </Button>
    );
  if (status === "active")
    return (
      <InlineLoading
        description={"Logging in..."}
        status={status}
        style={{ justifyContent: "center" }}
      />
    );
  if (status === "error")
    return (
      <>
        <InlineLoading
          description={"Authentication error"}
          status={status}
          style={{ justifyContent: "center", marginBottom: "8px" }}
        />
        <Button kind="tertiary" size="sm" onClick={() => setStatus(null)}>
          Try again
        </Button>
      </>
    );
}

const Welcome = () => {
  const { user } = useContext(AuthContext);
  if (user) return <Redirect to="/dashboard" />;
  return (
    <div style={{ textAlign: "center", marginTop: "10vh" }}>
      <FaceMask32 />
      <h1 style={{ marginTop: "0.25em", marginBottom: "1em" }}>
        Hi, stranger.
      </h1>
      <Login />
    </div>
  );
};

export default Welcome;
